export const YEAR2_APPROVED_TOPICS = [
  'Youth Mental Load',
  'Plastic in Daily Life',
  "Girls' Safety & Mobility",
  'Climate Anxiety & Youth Action',
  'Digital Overload & Youth Attention',
  'Fast Fashion & Textile Waste',
  'Financial Literacy & Youth Poverty',
  'Misinformation & Media Trust',
];